"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFeather = require("react-feather");
var _format = _interopRequireDefault(require("date-fns/format"));
var _helpers = require("./../../utils/helpers");
var _DateNavigationModule = _interopRequireDefault(require("./../../scss/navigations/DateNavigation.module.scss"));
function DateNavigation(_ref) {
  let {
    weeks = [[], []],
    handleDateChanged = () => true
  } = _ref;
  const [currentWeekIndex, setCurrentWeekIndex] = (0, _react.useState)(0);
  const [currentWeek, setCurrentWeek] = (0, _react.useState)(weeks[0]);
  const [selectedDay, setSelectedDay] = (0, _react.useState)(weeks[0][0]);
  const [navigationState, setNavigationState] = (0, _react.useState)('entering');
  const navigationList = (0, _react.useRef)(null);
  const dateIndex = (0, _react.useRef)(0);
  const handleControlClick = weekIndex => {
    setCurrentWeekIndex(weekIndex);
    setNavigationState(prevState => {
      if (weekIndex) return 'exiting';
      return 'entering';
    });
  };
  const handleDateClicked = date => {
    setSelectedDay(date);
    handleDateChanged(date.date);
  };
  const handleKeyPress = e => {
    if ((e.key === 'ArrowRight' || e.key === 'ArrowDown') && dateIndex.current < 6) ++dateIndex.current;
    if ((e.key === 'ArrowLeft' || e.key === 'ArrowUp') && dateIndex.current > 0) --dateIndex.current;
    e.currentTarget.children[dateIndex.current].children[0].focus();
  };
  const handleAnimationEnd = _react.default.useCallback(() => {
    navigationList.current.addEventListener('animationstart', () => {
      navigationList.current.addEventListener('animationend', handleAnimationEnd, {
        once: true
      });
    });
    setNavigationState('idle');
  }, []);
  (0, _react.useEffect)(() => {
    if (navigationList.current !== null) {
      navigationList.current.removeEventListener('animationend', handleAnimationEnd, {
        once: true
      });
      navigationList.current.addEventListener('animationend', handleAnimationEnd, {
        once: true
      });
    }
  }, [handleAnimationEnd]);
  (0, _react.useEffect)(() => {
    setCurrentWeek(weeks[currentWeekIndex]);
    setSelectedDay(previousDay => {
      const previousWeekIndex = currentWeekIndex ? 0 : 1;
      const dayIndex = weeks[previousWeekIndex].findIndex(d => (0, _format.default)(d.date, 'yyyy-MM-dd') === (0, _format.default)(previousDay.date, 'yyyy-MM-dd'));
      if (dayIndex === -1) {
        return previousDay;
      } else {
        var _weeks$currentWeekInd;
        handleDateChanged((_weeks$currentWeekInd = weeks[currentWeekIndex][dayIndex]) === null || _weeks$currentWeekInd === void 0 ? void 0 : _weeks$currentWeekInd.date);
        dateIndex.current = dayIndex;
        return weeks[currentWeekIndex][dayIndex];
      }
    });
  }, [currentWeekIndex, weeks, handleDateChanged]);
  return /*#__PURE__*/_react.default.createElement("date-navigation", {
    "data-state": navigationState
  }, /*#__PURE__*/_react.default.createElement("date-navigation-controls", null, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: [_DateNavigationModule.default['date-navigation__control'], _DateNavigationModule.default['date-navigation__control--previous'], 'date-navigation__control', 'date-navigation__control--previous'].join(' '),
    onClick: () => {
      handleControlClick(0);
    },
    disabled: currentWeekIndex === 0 ? true : null
  }, /*#__PURE__*/_react.default.createElement("i", {
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronLeft, {
    width: 48,
    height: 48
  }))), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: [_DateNavigationModule.default['date-navigation__control'], _DateNavigationModule.default['date-navigation__control--next'], 'date-navigation__control', 'date-navigation__control--next'].join(' '),
    onClick: () => {
      handleControlClick(1);
    },
    disabled: currentWeekIndex === 1 ? true : null
  }, /*#__PURE__*/_react.default.createElement("i", {
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement(_reactFeather.ChevronRight, {
    width: 48,
    height: 48
  })))), /*#__PURE__*/_react.default.createElement("date-navigation-list", null, /*#__PURE__*/_react.default.createElement("ul", {
    className: [_DateNavigationModule.default['date-navigation__list'], 'date-navigation__list'].join(' '),
    ref: navigationList,
    role: "tablist",
    "aria-label": "Date Tabs",
    onKeyDown: handleKeyPress
  }, currentWeek.map(day => {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: [_DateNavigationModule.default['date-navigation__item'], 'date-navigation__item'].join(' '),
      key: "schedule-nav-".concat(day.fullDateStr),
      role: "presentation"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: [_DateNavigationModule.default['date-navigation__day'], 'date-navigation__day'].join(' '),
      "aria-selected": selectedDay.fullDateStr === day.fullDateStr,
      onClick: () => {
        handleDateClicked(day);
      },
      role: "tab",
      "aria-controls": "".concat(day.fullDateStr)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: [_DateNavigationModule.default['date-navigation__weekday'], 'date-navigation__weekday'].join(' ')
    }, day.dayStr), /*#__PURE__*/_react.default.createElement("div", {
      className: [_DateNavigationModule.default['date-navigation__date'], 'date-navigation__date'].join(' ')
    }, day.monthStr, " ", /*#__PURE__*/_react.default.createElement("br", {
      className: (0, _helpers.classes)([_DateNavigationModule.default['date-navigation__month-day-break'], 'date-navigation__month-day-break'])
    }), day.dateStr)));
  }))));
}
var _default = exports.default = DateNavigation;